"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changeStatusBatchWatcher = changeStatusBatchWatcher;

var _effects = require("redux-saga/effects");

var types = _interopRequireWildcard(require("./types"));

var actions = _interopRequireWildcard(require("./actions"));

var _lodash = _interopRequireDefault(require("lodash"));

var _data = require("../../../../constants/data");

var _apiRequest = require("../../api/apiRequest");

var _selectors = require("../../../data/views/selectors");

var _actions2 = require("../../data/actions");

var _component = require("../../../../constants/component");

var _config = require("../../../../config");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(changeStatusBatch),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(changeStatusBatchWatcher);

function changeStatusBatch(action) {
  var _action$payload, index, filter, operation, state, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, dataView;

  return regeneratorRuntime.wrap(function changeStatusBatch$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _action$payload = action.payload, index = _action$payload.index, filter = _action$payload.filter, operation = _action$payload.operation;
          _context.next = 3;
          return (0, _effects.put)(actions.request(index));

        case 3:
          _context.prev = 3;
          _context.next = 6;
          return (0, _effects.call)(_apiRequest.apiRequest, _data.DATA_URLS.USER_PERMISSIONS_CHANGE_STATUS_BATCH_URL, "POST", {
            body: {
              filter: _lodash["default"].merge(filter, {
                viewPermissions: _config.Config.get("security", "viewPermissions")
              }),
              operation: operation
            }
          });

        case 6:
          _context.next = 8;
          return (0, _effects.select)();

        case 8:
          state = _context.sent;
          // Reload data app.views
          _iteratorNormalCompletion = true;
          _didIteratorError = false;
          _iteratorError = undefined;
          _context.prev = 12;
          _iterator = (0, _selectors.getDataViewsByDataType)(state, _data.DATA_TYPE.USER_PERMISSIONS)[Symbol.iterator]();

        case 14:
          if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
            _context.next = 21;
            break;
          }

          dataView = _step.value;
          _context.next = 18;
          return (0, _effects.put)((0, _actions2.saga)(_data.DATA_TYPE.USER_PERMISSIONS, dataView[_component.PROPS.DATA_SOURCE]));

        case 18:
          _iteratorNormalCompletion = true;
          _context.next = 14;
          break;

        case 21:
          _context.next = 27;
          break;

        case 23:
          _context.prev = 23;
          _context.t0 = _context["catch"](12);
          _didIteratorError = true;
          _iteratorError = _context.t0;

        case 27:
          _context.prev = 27;
          _context.prev = 28;

          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }

        case 30:
          _context.prev = 30;

          if (!_didIteratorError) {
            _context.next = 33;
            break;
          }

          throw _iteratorError;

        case 33:
          return _context.finish(30);

        case 34:
          return _context.finish(27);

        case 35:
          _context.next = 37;
          return (0, _effects.put)(actions.success(index));

        case 37:
          _context.next = 44;
          break;

        case 39:
          _context.prev = 39;
          _context.t1 = _context["catch"](3);
          console.error(_context.t1);
          _context.next = 44;
          return (0, _effects.put)(actions.failure(index));

        case 44:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[3, 39], [12, 23, 27, 35], [28,, 30, 34]]);
}

function changeStatusBatchWatcher() {
  return regeneratorRuntime.wrap(function changeStatusBatchWatcher$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.takeEvery)(types.SAGA, changeStatusBatch);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}